module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Metal.f14f6cda.png";